// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__33N2K","search":"Settings_search__12PIf","filter":"Settings_filter__2NDQr"};